import classNames from 'classnames';
import ProjectBadge from 'components/projects/ProjectBadge';
import { Table, Tbody, Td, Tr } from 'components/ui-blocks/table';
import React, { PureComponent } from 'react';
import styles from './ActivitiesTable.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  showContextColumn?: boolean;
}

export default class PlaceholderActivitiesTable extends PureComponent<Props> {
  createRows = () => {
    const { showContextColumn } = this.props;
    const output: Array<React.ReactElement> = [];
    for (let i = 0; i < 10; i++) {
      output.push(
        <Tr key={i} className={styles.row}>
          {showContextColumn && (
            <Td className={styles.badge}>
              <ProjectBadge icon color="#ccc" />
            </Td>
          )}
          {showContextColumn && (
            <Td className={styles.name}>
              <div className={styles.placeholderParagraph} />
            </Td>
          )}
          <Td className={styles.message}>
            <div className={styles.placeholderParagraph} />
          </Td>
          <Td className={styles.date}>
            <div className={styles.placeholderParagraph} />
          </Td>
        </Tr>
      );
    }
    return output;
  };
  render() {
    const { className, showContextColumn, ...rest } = this.props;
    const containerClass = classNames(styles.container, styles.placeholderContainer, className);
    return (
      <div {...rest} className={containerClass}>
        <Table>
          <Tbody>{this.createRows()}</Tbody>
        </Table>
      </div>
    );
  }
}
